import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Card from '../../components/cards/Card';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import SearchBar from '../../components/searchBar/SearchBar';
import { Link } from 'react-router-dom';
import Button from '../../components/buttons/Button';
import { toast } from 'react-toastify';
import { BiEdit, BiLink, BiRefresh } from 'react-icons/bi';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import { getDomains } from '../../services/domains';

function Domains() {
    const [cardData, setCardData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "Name", key: "name" },
        { label: "Order", key: "order" },
        { label: "Image", key: "image" },
        { label: "Description", key: "description" },
        { label: "Category Count", key: "category_count" },
        { label: "Action", key: "action" },
    ];

    const [searchText, setSearchText] = useState("");

    const pageSize = 10;

    const handleSearch = (query) => {
        setSearchText(query);
        fetchData(`?search=${query}`);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getDomains(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error in Manufacturers:", error);
        } finally {
            setLoading(false);
        }
    };

    const resetFilters = () => {
        setSearchText("");
        fetchData("");
    };

    useEffect(() => {
        fetchData("");
    }, []);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Bazaar' },
            { name: 'Domains' },
        ]} />
        <div className="py-3">
            <StyledHeadingText text={"Domains"} />
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        <div className="flex flex-row justify-between item-center">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 justify-center items-center max-w-4xl">
                <SearchBar placeholder="Search by name" onSearch={handleSearch} value={searchText} />
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4 justify-center items-center">
                    <div className="flex flex-row items-center gap2">
                        {
                            searchText.length !== 0 ?
                                <BiRefresh size={24} className='cursor-pointer text-primary' onClick={resetFilters} /> : <></>
                        }
                    </div>
                </div>
            </div>
            <Link to="/bazzar/domains/add" className='self-center'>
                <Button
                    type="button"
                    className="hover:bg-black hover:opacity-70 text-white bg-black rounded-md"
                >
                    Add Domain
                </Button>
            </Link>
        </div>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                name: <p>{item.name}</p>,
                                order: <p>{item.order}</p>,
                                description: <span className='flex flex-row gap-1 items-center'><p className="max-w-40 truncate cursor-help" title={item.description}>{item.description}</p></span>,
                                category_count: <p>{item.category_count}</p>,
                                image: <img src={item.image} alt={item.image} className='w-12 aspect-square rounded-sm border object-contain' />,
                                action: <Link to={`/bazzar/domains/${item.name}/`} state={item}><BiEdit size={24} color='green' /></Link>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
    </>);
}

export default Domains;